export const requireSuccessfulResponse = (
  response,
  fallbackMessage = "The request could not be completed",
) => {
  const resolvedResponse = response?.response || response;
  const status = resolvedResponse?.status;
  const data = resolvedResponse?.data;
  const isSuccessfulStatus =
    typeof status === "number" && status >= 200 && status < 300;

  if (!isSuccessfulStatus || data?.success !== true) {
    const error = new Error(
      data?.error || data?.message || response?.message || fallbackMessage,
    );
    error.response = resolvedResponse;
    throw error;
  }

  return data;
};
